// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes shimmer-loading--czIGY{0%{background-position:200% 0}100%{background-position:-200% 0}}body{background-attachment:fixed;background-image:#f0f0f4}.unsubscribe-page--4F9Ct{background-color:#f0f0f4;height:100vh;height:100dvh}.footer--o_r82{background-color:#f0f0f4}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"unsubscribe-page": "unsubscribe-page--4F9Ct",
	"footer": "footer--o_r82",
	"shimmer-loading": "shimmer-loading--czIGY"
};
export default ___CSS_LOADER_EXPORT___;
